
<div class="row my-5">
  <div class="col-sm-4"><app-dream></app-dream></div>
  <div class="col-sm-8">
    <app-free-download></app-free-download>
    <div class="Markdown-post">
        <ng-container *ngIf="post$ | async as post">
            <div id="markdown-post2" class="pe-5" markdown [src]="post"></div>
        </ng-container>
      </div>
      <app-free-download></app-free-download>
      <app-benefit-related-post [currentSlugPost]="slug"></app-benefit-related-post>
</div>
</div>
